// extracted by mini-css-extract-plugin
module.exports = {"form":"SimpleForm_form__oif-u","item":"SimpleForm_item__3KdKh"};